import withAemIntegration from "../../withAemIntegration";
import loadable from "../../utils/loadable";
const Component = loadable(() =>
  import("@lexus.com/ui/dist/modules/LCertSearchInventory")
);

const SearchInventoryEditConfig = {
  emptyLabel: "Search Inventory",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const transformData = (data) => {
  return {
    id: data.id || "LcertSearchInventory",
    resultsView: data.resultsView,
    heading: data.resultsView?.heading || "Search Inventory",
    filterBar: {
      ...data.filterBar,
      tabs: (data.filterBar?.tabs || []).map((item) => {
        return {
          ...item,
          value: item?.label,
          name: item?.label?.toUpperCase(),
        };
      }),
      tabsFilter: {
        heading: data.filterBar?.tabsFilter?.heading,
        buttonTheme: data.filterBar?.tabsFilter?.buttonTheme || "SecondaryGold",
      },
    },
    filterBreadcrumbs: data.filterBreadcrumbs,
    disclaimer: {
      body: data.resultsView?.efcDisclaimerBody || "",
      heading: data.resultsView?.efcDisclaimerHeadline || "",
    },
    overlayData: data.vinDetailsOverlay,
    purchaseFormData: {
      ...data.formData,
      serverErrorMessaging: {
        errorHeader: data.formData?.serviceDownMessage?.heading,
        errorDescription: data.formData?.serviceDownMessage?.text,
      },
    },
    zipGate: data.zipGate,
    sortInfo: {
      options: (data.resultsView?.sortOptions || []).map((item) => {
        return { label: item.name, value: item.value };
      }),
    },
    serviceDownMessage: data.serviceDownMessage,
  };
};

const SearchInventory = (props) => {
  const data = transformData(props);

  return <Component {...data} />;
};

export default withAemIntegration("lexus/components/search-inventory")(
  SearchInventory,
  SearchInventoryEditConfig
);
